import { render, staticRenderFns } from "./AskedFilters.vue?vue&type=template&id=ecf71dc0"
import script from "./AskedFilters.vue?vue&type=script&lang=ts"
export * from "./AskedFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports